module.exports = __webpack_public_path__ + "7a2f985ca24e798b24a2ee976607e204.MP3";